import React, { useRef, useEffect } from "react";

import * as styles from './style.module.scss';

const { 
    cRightClickLogo,     
    cRightClickLogo__menu,
    cRightClickLogo__menuButton,
} = styles;

const RightClickLogoMenu = ({ children, menuItems = [] }) => {
  const logoRef = useRef(null);

  useEffect(() => {
    const logoContainer = logoRef.current;
    const menuButtons = logoContainer.querySelectorAll(`.${cRightClickLogo__menuButton}`);

    const handleContextMenu = (e) => {
      e.preventDefault();
      logoContainer.classList.toggle("js-is-active");
    };

    const handleClickOutside = (e) => {
      if (!logoContainer.contains(e.target)) {
        logoContainer.classList.remove("js-is-active");
      }
    };

    const handleMenuButtonClick = async (button) => {
        const action = button.dataset.type;
        const url = button.dataset.link;
      
        button.classList.add("js-is-active");
        setTimeout(() => {
          button.classList.remove("js-is-active");
        }, 1000);

        if (url.endsWith(".zip")) {
          window.open(url, "_blank");
          return;
        }

        if (action === "copy") {
          try {
            const response = await fetch(url, { mode: 'cors' });
            if (!response.ok) throw new Error('Network response was not ok');
            
            const blob = await response.blob();
            const item = new ClipboardItem({ [blob.type]: blob });
            await navigator.clipboard.write([item]);
            console.log("✅ Image copied to clipboard!");
          } catch (err) {
            console.error("Failed to copy image:", err);
            
            const a = document.createElement("a");
            a.href = url;
            a.download = "logo.png";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        }
      };
      

    logoContainer.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("click", handleClickOutside);
    menuButtons.forEach((button) =>
      button.addEventListener("click", () => handleMenuButtonClick(button))
    );

    return () => {
      logoContainer.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className={cRightClickLogo} ref={logoRef}>
    <div className={styles.cRightClickLogo__link}>
      {children}
      <div className={styles.cRightClickLogo__tooltip}>
        Right-click to download logo
      </div>
    </div>
    <div className={cRightClickLogo__menu}>
      {menuItems.map(({ label, type, link, icon }, i) => (
        <button
          key={i}
          className={cRightClickLogo__menuButton}
          data-type={type}
          data-link={link}
        >
          {icon}
          {label}
        </button>
      ))}
    </div>
  </div>
  
  );  
};

export default RightClickLogoMenu;
